export var PublisherPrefixErrorTypes;
(function (PublisherPrefixErrorTypes) {
    PublisherPrefixErrorTypes["DUPLICATE"] = "-1";
    PublisherPrefixErrorTypes["CHILDREN"] = "-22";
})(PublisherPrefixErrorTypes || (PublisherPrefixErrorTypes = {}));
